import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c461eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "living-person" }
const _hoisted_2 = {
  key: 0,
  class: "subtext"
}

import { computed } from 'vue'
import { Person } from '@webapp/rd/ResearchDataModel'
import { useSyncSessionStore } from './SyncSessionStore'
import Checkbox from '@webapp/util/Checkbox.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LivingPersonListItem',
  props: {
    person: {},
    sessionId: {}
  },
  setup(__props: any) {

const props = __props;



const syncSessionStore = useSyncSessionStore()
const stateRef = computed(() => syncSessionStore.getState(props.sessionId))

const subtextItemsRef = computed(() => {
  const items: (string | number)[] = []
  if (props.person.displayProperties.birthYear) {
    items.push(props.person.displayProperties.birthYear)
  }
  if (props.person.displayProperties.assumeDeceased) {
    items.push('deceased')
  }
  return items
})

const isMappedRef = computed(() =>
  stateRef.value?.sourceGraph?.mappedPersonIds.has(props.person.id!) ?? false)
const isInLivingWindowRef = computed(() =>
  stateRef.value?.sourceGraph?.livingWindowPersonIds.has(props.person.id!) ?? false)
const isIncludedRef = computed(() =>
  stateRef.value?.livingWindowPersonIds.includes(props.person.id!) ?? false)

const selectedRef = computed({
  get: () => isMappedRef.value || isIncludedRef.value || !isInLivingWindowRef.value,
  set: value => {
    if (!isInLivingWindowRef.value) {
      throw new Error('Person not in living window')
    }
    const includeIds = stateRef.value?.livingWindowPersonIds
    if (!includeIds) {
      return
    }
    if (value) {
      if (!includeIds.includes(props.person.id!)) {
        includeIds.push(props.person.id!)
      }
    }
    else {
      const index = includeIds.indexOf(props.person.id!)
      if (index > -1) {
        includeIds.splice(index, 1)
      }
    }
  },
})

const disabledRef = computed(() => isMappedRef.value || !isInLivingWindowRef.value)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Checkbox, {
      checked: selectedRef.value,
      disabled: disabledRef.value,
      "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => (selectedRef.value = !selectedRef.value))
    }, null, 8, ["checked", "disabled"]),
    _createElementVNode("div", null, [
      _createTextVNode(_toDisplayString(props.person?.displayName) + " ", 1),
      (subtextItemsRef.value.length)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (" + _toDisplayString(subtextItemsRef.value.join(', ')) + ") ", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})